import { useState } from "react";
import { getLocalId } from "easy-analytics/client";
import { api, handleError } from "../../services/api";

import { Footer, Header } from "../../Layout";

import { useRouter } from "easy-page-router/react";
import { useHead } from "../../services/common";
import { useLang } from "../../services/lang";
import { ThemeSelect, ThemeSwitch } from "../../components/Theme";
import { LangSwitch } from "../../components/Lang";
import { Checkbox, CheckboxPublic, Input } from "../../components/Form";
import { Loading, Page } from "../../components";

import { Who } from "../../../types";

const emptyWho: Who = {
    _id: "",
    userId: "",
    changed: "",
    lang: "en",
    theme: "",
    title: "",
    description: "",
    isMaybeOption: false,
    when: "",
    where: "",
    public: false,
    users: {},
    votes: {},
}


export default function WhoForm() {
    const { push } = useRouter();
    const { lang, dict } = useLang();

    useHead({
        title: dict.seo.whoForm.title,
        description: dict.seo.whoForm.description,
    });

    const [who, setWho] = useState(emptyWho);
    const [message, setMessage] = useState("");
    const [isSending, setIsSending] = useState(false);


    async function handleSave() {
        if (!who.title) {
            return setMessage(dict.whoFormMissingTitle);
        }

        setIsSending(true);
        setMessage("");

        const [id, error] = await api.addWho({
            ...who,
            userId: getLocalId(),
            lang,
        });

        setIsSending(false);

        if (!id) {
            handleError(error);
            setMessage(dict.whoFormError);
        } else {
            setMessage(dict.whoFormSuccess);
            push(`/${dict.urlWho}/${id}`);
        }
    }

    console.log(who);

    return <Page fixed={<>
        <Header title={dict.who} link={`/${dict.urlWho}`}>
            <LangSwitch />
            <ThemeSwitch />
        </Header>
        <Footer />
    </>}>

        <h1>{dict.newWho}</h1>

        <div className="form">
            <label>{dict.theme}</label>
            <ThemeSelect
                value={who.theme}
                onChange={theme => setWho({ ...who, theme })}
            />

            <Input autoFocus label={dict.whoFormTitle} field="title" maxLength={100} required value={who} setValue={setWho} />
            <Input label={dict.whoFormDescription} field="description" maxLength={500} type="textarea" value={who} setValue={setWho} />

            <label onClick={() => setWho({ ...who, isMaybeOption: !who.isMaybeOption })}>
                <Checkbox value={who.isMaybeOption} />
                {dict.whoFormIsMaybeOption}
            </label>

            <Input label={dict.whoFormWhere} field="where" maxLength={50} value={who} setValue={setWho} />
            <div style={{ display: "flex", alignItems: "flex-end" }}>
                <div style={{ flexGrow: 1, flexBasis: "200px" }}>
                    <Input label={dict.whoFormWhen} field="when" type="datetime-local" value={who} setValue={setWho} />
                </div>
                {who.when && <a style={{ fontSize: "20px", padding: "9px", paddingLeft: "20px" }} onClick={() => setWho({ ...who, when: "" })}>✘</a>}
            </div>

            <CheckboxPublic
                value={who}
                onChange={setWho}
                label={dict.pollFormPublic}
                captionPublic={dict.pollFormPublicCaption}
                captionPrivate={dict.pollFormPrivateCaption}
            />

            {message && <p className="alert">{message}</p>}

            {isSending && <Loading />}
            {!isSending && <button onClick={handleSave}>{dict.whoCreate}</button>}
        </div>

    </Page>;
}